import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RecentlyItem } from '@frontend-site/shared/data';
import { NavigationStore } from '@frontend-site/shared/core';
import { HybridCommunicationService } from '@frontend-site/shared/hybrid';
import { Router } from '@angular/router';

@Component({
    selector: 'p-recently-viewed-item',
    templateUrl: './recently-viewed-item.component.html',
    styleUrls: ['./recently-viewed-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecentlyViewedItemComponent {
    @Input() data: RecentlyItem = {} as RecentlyItem;
    @Output() closed = new EventEmitter<void>();

    constructor(
        private navigationStore: NavigationStore,
        private router: Router,
        private hybridCommunicationService: HybridCommunicationService
    ) {}

    public itemLinkClicked(): void {
        this.closed.emit();
        this.navigationStore.updateNavigationIds([]);
        this.hybridCommunicationService.sendUpdateNavigationIds([], 0);
    }

    public itemClicked(): void {
        this.router.navigate([this.data.url], { queryParams: this.data.queryParams });
        this.itemLinkClicked();
    }
}
